export const styles = {
  grow: {
    flexGrow: 1
  }
}



// WEBPACK FOOTER //
// ./src/pages/Reports/styles.js